import Urls from "./url"

/**
 * 
 * @returns 
 */
export const fetchCatsIn = async (ids:[number]) => {
    const url = Urls('listCategoriesIn',ids.join(','));
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
/**
 * 
 * @returns 
 */
export const fetchCats = async () => {
    const url = Urls('listCategories');
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
/**
 * 
 * @returns 
 */
export const fetchTags = async () => {
    const url = Urls('listTags');
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}


export default {}